import { useLocation } from 'react-router-dom';
import { Header } from '@components/layout/Header';
import { Navbar } from '@components/layout/Navbar';
import { Footer } from '@components/layout/Footer';
import { getWrapClass } from '@configs/routes';
import type { ComponentProps } from '@shared/components';
import { AnalyticsProvider } from '@hooks/analytics';
import { useAuthStore } from '@stores/auth-store';

/**
 * 공통 레이아웃 컴포넌트
 * Header, Navbar, Footer를 포함한 기본 레이아웃을 제공합니다.
 */
export const CommonLayout = ({ children }: Readonly<ComponentProps>) => {
  const location = useLocation();
  const wrapClass = getWrapClass(location.pathname);
  const { user } = useAuthStore();

  return (
    <AnalyticsProvider userId={user?.loginId}>
      <div className={wrapClass}>
        <Header />
        <Navbar />
        {children}
        <Footer />
      </div>
    </AnalyticsProvider>
  );
};
